<script setup lang="ts">
import type { BoardCard } from "@/model/card";

import StickyTypeBreakdown from "./StickyTypeBreakdown.vue";

defineProps<{ heading: string; cards: BoardCard[] }>();
</script>

<template>
  <section v-if="cards.length > 0" class="bulk-action-group">
    <h3 class="heading">{{ heading }}</h3>
    <StickyTypeBreakdown :cards />
    <slot />
  </section>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/typography";

.bulk-action-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.heading {
  @include typography.medium("bold");

  margin: 0;
}
</style>
